export const isApplePrivateRelayEmail = (email: string): boolean =>
  email.endsWith('@privaterelay.appleid.com');
